import axios from "axios";
import { GridColDef,GridRenderCellParams } from '@mui/x-data-grid';

import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircle from "@mui/icons-material/CheckCircle";
import moment from "moment";
import "i18n/config";
import i18next from "i18next";
const colors = {      
  '-': '',
  0: '#FFFFFF',
  1: '#2CC937',
  2: '#99C140',
  3: '#E7B417',
  4: '#DB7B2A',
  5: '#CC3232'
} as any;

export const assessmentList = async (organization_id:string) => {
    let url = process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/executive-view/organization/"+organization_id+"/assessments/";
    let response = await axios.get(url);
    return response.data;
};

export const assessmentRisk = async (organization_id:string, assessment_id?:string) => {
  if(!assessment_id) assessment_id = '';
  let url = process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/executive-view/organization/"+organization_id+"/risks/"+assessment_id;
  let response = await axios.get(url);
  return response.data;
};

export const configurationProgress = async (organization_id:string) => {
  let url = process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/executive-view/organization/"+organization_id+"/progress/";
  let response = await axios.get(url);
  return response.data;
};

export async function assessmentListColumns(locale:string) {
    i18next.changeLanguage(locale);
    return [
      { 
        field: 'name', 
        headerName: i18next.t('Name'), 
        width: 150,
      },
      {
        field: 'fncs',
        headerName: 'FNCS',
        flex: 1,
        editable: false,
        renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle sx={{fontSize:16}} /> : '',
      },
      {
        field: 'gdpr',
        headerName: 'GDPR',
        flex: 1,
        editable: true,
        type: "singleSelect",
        valueOptions: [
          { value: 1, label: 'Yes' },
          { value: 0, label: 'No' }
        ],
        renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle sx={{fontSize:16}} /> : '',
      },   
      {
        field: 'psnc',
        headerName: 'PSNC',
        flex: 1,
        editable: true,
        type: "singleSelect",
        valueOptions: [
          { value: 1, label: 'Yes' },
          { value: 0, label: 'No' }
        ],
        renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle sx={{fontSize:16}} /> : '',
        },   
        {
          field: 'nis2',
          headerName: 'NIS2',
          flex: 1,
          editable: true,
          type: "singleSelect",
          valueOptions: [
            { value: 1, label: 'Yes' },
            { value: 0, label: 'No' }
          ],
          renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle sx={{fontSize:16}} /> : '',
          },      
        {
          field: 'score',
          headerName: i18next.t('Coverage'),
          flex: 1,
          editable: false,
          valueGetter: params => params.row.score.all || '',
          valueFormatter: params => params?.value ? params?.value + '%' : '',
        },
        {
          field: 'maturity',
          headerName: i18next.t('Maturity'),
          flex: 1,
          editable: false,
          valueGetter: params => params.row.maturity.all || '',
          valueFormatter: params => params?.value ? params?.value + '%' : '',
        },
        {
          field: 'risk_detail',
          headerName: i18next.t('Risk'),
          flex: 1,
          editable: false,
          valueGetter: params => params.row.risk_detail || '',
          
          renderCell: (params: GridRenderCellParams<any>) =>
            <Box sx={{ backgroundColor: colors[Math.ceil(params.value)], height:50, width:80, color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {params.value}
            </Box>
        },
        {
        field: 'progress',
        headerName: i18next.t('% Questionario'),
        width: 150,
        renderCell: (params: GridRenderCellParams<any>) =>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: 70, mr: 1 }}>
            <LinearProgress variant="determinate" value={params.value} color="info"/>
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.primary">{`${Math.round(
              params.value
            )}%`}</Typography>
          </Box>
        </Box>
      },
      {
        field: 'num_controls_unique',
        headerName: i18next.t('Contr.'),
        width: 80
      },
      {
        field: 'num_treatments',
        headerName: i18next.t('Treat.'),
        width: 80,
        valueFormatter: params => params?.value ? params?.value : '',
      },
      { 
        field: 'treatments_end',
        headerName: i18next.t('End'),
        width: 120,
        valueFormatter: params => params?.value ? moment(params?.value).format('DD/MM/YYYY') : '',
      },
      { 
        field: 'strategy_approved',
        headerName: i18next.t('Appr.'),
        width: 80,
        renderCell: (params: GridRenderCellParams<any, Date>) => params.value ? <CheckCircle sx={{fontSize:16}} /> : '',
      }
    ] as GridColDef[]
  };